import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchers } from "../fetchers";

const SUBSCRIPTION_KEY = "subscription";

const useCreateStripeCustomer = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [SUBSCRIPTION_KEY],
    mutationFn: fetchers.stripe.createStripeCustomer,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SUBSCRIPTION_KEY] });
    },
  });
};

const useCreateStripeSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [SUBSCRIPTION_KEY],
    mutationFn: fetchers.stripe.createStripeSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SUBSCRIPTION_KEY] });
    },
  });
};

const useCreateStripeTrialSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [SUBSCRIPTION_KEY],
    mutationFn: fetchers.stripe.createStripeTrialSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SUBSCRIPTION_KEY] });
    },
  });
};

const useSubscriptionByUserId = (userId: string | null) => {
  return useQuery({
    queryKey: [SUBSCRIPTION_KEY, userId],
    queryFn: () => (userId ? fetchers.stripe.fetchSubscription(userId) : undefined),
    enabled: !!userId,
  });
};

const useCancelSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [SUBSCRIPTION_KEY],
    mutationFn: fetchers.stripe.cancelSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SUBSCRIPTION_KEY] });
    },
  });
};

const useResumeSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [SUBSCRIPTION_KEY],
    mutationFn: fetchers.stripe.resumeSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SUBSCRIPTION_KEY] });
    },
  });
};

export const subscriptionHooks = {
  useCreateStripeCustomer,
  useCreateStripeSubscription,
  useCreateStripeTrialSubscription,
  useCancelSubscription,
  useResumeSubscription,
  useSubscriptionByUserId,
};
